var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("validation-observer", {
        ref: "formAddJournalEntry",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var invalid = ref.invalid
              return [
                _c(
                  "b-form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.submitJournalEntry($event)
                      },
                    },
                  },
                  [
                    _c(
                      "b-card",
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "my-md-1",
                                attrs: { md: "6", cols: "6" },
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Transaction Date",
                                      "label-for": "transactionDateInput",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        rules: "required",
                                        name: "Transaction Date",
                                        vid: "Transaction Date",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-datepicker", {
                                                  attrs: {
                                                    id: "transactionDateInput",
                                                    max: _vm.today,
                                                    required: "",
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.transactionDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "transactionDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.transactionDate",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              {
                                staticClass: "my-md-1",
                                attrs: { md: "6", cols: "6" },
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Reference",
                                      "label-for": "referenceInput",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        rules: "required",
                                        name: "Reference",
                                        vid: "Reference",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "referenceInput",
                                                    type: "text",
                                                    required: "",
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                  },
                                                  model: {
                                                    value: _vm.form.reference,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "reference",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.reference",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-card",
                      { staticClass: "mt-3" },
                      [
                        _c(
                          "div",
                          { staticClass: "float-right my-1" },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "primary" },
                                on: { click: _vm.addRow },
                              },
                              [_vm._v("Add Row")]
                            ),
                          ],
                          1
                        ),
                        _vm.loading
                          ? _c(
                              "b-col",
                              {
                                staticClass: "text-center my-2",
                                attrs: { cols: "12" },
                              },
                              [
                                _c("b-spinner", {
                                  staticStyle: {
                                    width: "3rem",
                                    height: "3rem",
                                  },
                                  attrs: {
                                    variant: "success",
                                    label: "Spinning",
                                    block: "",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.loading
                          ? _c("b-table", {
                              attrs: {
                                responsive: "",
                                items: _vm.tableData,
                                fields: _vm.tableFields,
                                striped: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "cell(ACCOUNT)",
                                    fn: function (row) {
                                      return [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "required",
                                            name: "Account",
                                            vid: "account_" + row.index,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        options:
                                                          _vm.optionsAccount,
                                                        required: "",
                                                        state:
                                                          errors.length > 0
                                                            ? false
                                                            : null,
                                                      },
                                                      model: {
                                                        value: row.item.ACCOUNT,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row.item,
                                                            "ACCOUNT",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "row.item.ACCOUNT",
                                                      },
                                                    }),
                                                    errors.length
                                                      ? _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-danger text-end",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(DEBIT)",
                                    fn: function (row) {
                                      return [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "required",
                                            name: "Debit",
                                            vid: "debit_" + row.index,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        type: "text",
                                                        disabled:
                                                          row.item.CREDIT !== 0,
                                                        required: "",
                                                        state:
                                                          errors.length > 0
                                                            ? false
                                                            : null,
                                                      },
                                                      model: {
                                                        value: row.item.DEBIT,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row.item,
                                                            "DEBIT",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "row.item.DEBIT",
                                                      },
                                                    }),
                                                    errors.length
                                                      ? _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-danger text-end",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(CREDIT)",
                                    fn: function (row) {
                                      return [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "required",
                                            name: "Credit",
                                            vid: "credit_" + row.index,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        type: "text",
                                                        disabled:
                                                          row.item.DEBIT !== 0,
                                                        required: "",
                                                        state:
                                                          errors.length > 0
                                                            ? false
                                                            : null,
                                                      },
                                                      model: {
                                                        value: row.item.CREDIT,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row.item,
                                                            "CREDIT",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "row.item.CREDIT",
                                                      },
                                                    }),
                                                    errors.length
                                                      ? _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-danger text-end",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(CONTACT)",
                                    fn: function (row) {
                                      return [
                                        _c("b-form-select", {
                                          attrs: {
                                            options: _vm.optionsContact,
                                          },
                                          model: {
                                            value: row.item.CONTACT,
                                            callback: function ($$v) {
                                              _vm.$set(row.item, "CONTACT", $$v)
                                            },
                                            expression: "row.item.CONTACT",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(DESCRIPTION)",
                                    fn: function (row) {
                                      return [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "required",
                                            name: "Description",
                                            vid: "description_" + row.index,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-textarea", {
                                                      attrs: {
                                                        rows: "3",
                                                        required: "",
                                                        state:
                                                          errors.length > 0
                                                            ? false
                                                            : null,
                                                      },
                                                      model: {
                                                        value:
                                                          row.item.DESCRIPTION,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row.item,
                                                            "DESCRIPTION",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "row.item.DESCRIPTION",
                                                      },
                                                    }),
                                                    errors.length
                                                      ? _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-danger text-end",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(AMOUNT)",
                                    fn: function (row) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.getAmount(row))),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(Actions)",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            attrs: { href: "#" },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.deleteEntry(
                                                  data.index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("feather-icon", {
                                              staticClass:
                                                "text-body align-middle",
                                              attrs: { icon: "TrashIcon" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : _vm._e(),
                        !_vm.loading
                          ? _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "d-flex justify-content-end",
                                    attrs: { md: "12" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "py-1 px-2 d-flex" },
                                      [
                                        _c("h5", [_vm._v("Total Debit:")]),
                                        _c("span", { staticClass: "ml-5" }, [
                                          _vm._v(_vm._s(_vm.getTotalDebit)),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "d-flex justify-content-end",
                                    attrs: { md: "12" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "py-1 px-2 d-flex" },
                                      [
                                        _c("h5", [_vm._v("Total Credit:")]),
                                        _c("span", { staticClass: "ml-5" }, [
                                          _vm._v(_vm._s(_vm.getTotalCredit)),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      {
                        staticClass: "d-flex justify-content-end",
                        attrs: { md: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "primary",
                              type: "button",
                              disabled: _vm.isSubmitting,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.submitJournalEntry()
                              },
                            },
                          },
                          [_vm._v("Save")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }